// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CurrencySeparator: MarkdocTagRegistration = {
  tag: 'currency-separator',
  component: 'CurrencySeparator',
  attributes: {
    currencies: {
      type: Array,
      required: true,
    },
  },
};
